import { useUiStore } from '@app/core/ui/stores/ui.store';
import {
  getDarkSurfaceScrollbarSx,
  getLightSurfaceScrollbarSx,
} from '@app/core/ui/thin-scrollbar-sx';
import { Box, List } from '@mui/material';
import React from 'react';
import { NavSeparator } from './base';
import { NavFooter } from './footer/NavFooter';
import { SidenavHeader } from './header/SidenavHeader';
import { isSidenavLightSurface } from './sidenav-colors';
import { SIDENAV_TOKENS } from './sidenav-tokens';
import { SidenavContextProvider } from './SidenavContext';
import { Drawer } from './SidenavDrawer';

/**
 * App shell sidenav: reads UI store for collapsed state and renders the permanent drawer
 * (header, scrollable nav list, pinned footer toggle).
 */
export function Sidenav({ children }: { children?: React.ReactNode }) {
  const isExpanded = useUiStore((state) => state.sidenavOpen);
  const collapsed = !isExpanded;
  const tokens = SIDENAV_TOKENS;

  return (
    <Drawer variant="permanent" open={isExpanded}>
      <SidenavContextProvider collapsed={collapsed}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            paddingTop: tokens.headerPaddingTop,
          }}
        >
          <SidenavHeader />
          <NavSeparator sx={{ my: 1.25 }} />
          <Box
            sx={(theme) => ({
              flex: 1,
              overflowY: 'auto',
              // Paper also sets thin chrome; this is the box that actually scrolls.
              ...(isSidenavLightSurface(theme)
                ? getLightSurfaceScrollbarSx()
                : getDarkSurfaceScrollbarSx()),
            })}
          >
            <List disablePadding>{children}</List>
          </Box>
          <NavFooter />
        </Box>
      </SidenavContextProvider>
    </Drawer>
  );
}
